import * as IconSelector from '../icons';

export const mediosPago = [
    {
        value: 'ccc',
        label: 'Cuenta Corriente',
        description: 'Cuenta Corrinte',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Tarjeta',
        label: 'Tarjeta',
        description: 'Tarjeta Debito/Credito',
        icon: IconSelector.PointIcon,
        color: 'Black'
    },
    {
        value: 'Poliza',
        label: 'Póliza',
        description: 'Póliza',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: 'Credito',
        label: 'Crédito',
        description: 'Crédito',
        icon: IconSelector.PointIcon,
        color: 'Red'
    },
    {
        value: 'Adeudos',
        label: 'Adeudos',
        description: 'Linea de Adeudos',
        icon: IconSelector.PointIcon,
        color: 'Orange'
    }
];
